import React, { useState, useEffect } from "react";
import { FaStar, FaTimes, FaPaperPlane } from "react-icons/fa";
import FingerprintJS from '@fingerprintjs/fingerprintjs'; // تأكد من تثبيت المكتبة

const RatingModal = ({ isOpen, onClose, establishmentId, establishmentName, backEnd_request }) => {
    const [ratingData, setRatingData] = useState({ comment: "", stars: 0 });
    const [visitorId, setVisitorId] = useState(""); // حالة لتخزين بصمة الجهاز
    const [hover, setHover] = useState(0);
    const [submitting, setSubmitting] = useState(false);
    const [status, setStatus] = useState({ type: "", msg: "" });

    // توليد بصمة الجهاز عند فتح المودال
    useEffect(() => {
        if (isOpen) {
            const getFingerprint = async () => {
                try {
                    const fp = await FingerprintJS.load();
                    const result = await fp.get();
                    setVisitorId(result.visitorId);
                } catch (err) {
                    console.error("فشل في جلب بصمة الجهاز", err);
                }
            };
            getFingerprint();
        }
    }, [isOpen]);

    if (!isOpen) return null;

    const handleRatingSubmit = async (e) => {
        e.preventDefault();

        if (ratingData.stars === 0) {
            return setStatus({ type: "danger", msg: "يرجى اختيار التقييم بالنجوم." });
        }

        if (!visitorId) {
            return setStatus({ type: "danger", msg: "جاري التعرف على الجهاز، يرجى الانتظار ثانية..." });
        }

        setSubmitting(true);
        setStatus({ type: "info", msg: "جاري إرسال تقييمك..." });

        // إنشاء الإيميل المخفي بناءً على البصمة
        const generatedEmail = `${visitorId}@custpro`;

        try {
            await backEnd_request.post(`/public/establishments/${establishmentId}/ratings`, {
                email: generatedEmail, // الإيميل المولد تلقائياً
                comment: ratingData.comment,
                ratingValue: ratingData.stars
            });

            setStatus({ type: "success", msg: "شكراً لك! تم استقبال تقييمك." });

            setTimeout(() => {
                onClose();
                setRatingData({ comment: "", stars: 0 });
                setStatus({ type: "", msg: "" });
            }, 2000);
        } catch (error) {
            setStatus({ type: "danger", msg: "فشل الإرسال، حاول لاحقاً." });
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-glass-card shadow-lg" onClick={e => e.stopPropagation()}>
                <div className="text-center mb-4">
                    <button className="btn-close-circle" onClick={onClose} style={{ position: 'absolute', top: '20px', right: '20px' }}>
                        <FaTimes />
                    </button>
                    <div className="icon-badge-yellow mx-auto mb-3">
                        <FaStar />
                    </div>
                    <h5 className="fw-bold text-dark mb-0">تقييم الفعالية</h5>
                    <small className="text-muted">{establishmentName}</small>
                </div>

                {status.msg && (
                    <div className={`alert alert-${status.type} py-2 small text-center border-0 mb-3`}>
                        {status.msg}
                    </div>
                )}

                <form onSubmit={handleRatingSubmit}>
                    {/* اختيار النجوم */}
                    <div className="stars-container text-center mb-4">
                        <div className="d-flex justify-content-center gap-2">
                            {[...Array(5)].map((_, i) => (
                                <FaStar key={i}
                                    style={{ cursor: 'pointer', fontSize: '2.5rem', transition: '0.2s' }}
                                    color={(i + 1) <= (hover || ratingData.stars) ? "#fbbf24" : "#e2e8f0"}
                                    onMouseEnter={() => setHover(i + 1)}
                                    onMouseLeave={() => setHover(0)}
                                    onClick={() => setRatingData({ ...ratingData, stars: i + 1 })}
                                />
                            ))}
                        </div>
                        <div className="mt-2 fw-bold text-warning">{ratingData.stars} من 5</div>
                    </div>

                    {/* ملاحظة: تم حذف حقل الإيميل من هنا ليكون مخفياً */}

                    <div className="mb-4">
                        <label className="form-label small fw-bold text-muted">رأيك بالتجربة (اختياري)</label>
                        <textarea rows="3" className="form-control bg-light border-0 py-3 px-3"
                            placeholder="أخبرنا بالمزيد عن تجربتك..."
                            style={{ borderRadius: '15px' }}
                            value={ratingData.comment}
                            onChange={e => setRatingData({ ...ratingData, comment: e.target.value })}
                        ></textarea>
                    </div>

                    <button type="submit" disabled={submitting || !visitorId} className="btn btn-warning w-100 fw-bold py-3 text-dark shadow-sm border-0 rounded-4">
                        {submitting ? "جاري الإرسال..." : <><FaPaperPlane className="ms-2" /> إرسال التقييم</>}
                    </button>
                </form>
            </div>

            <style>{`
                .modal-overlay { position: fixed; top:0; left:0; width:100%; height:100%; background: rgba(15, 23, 42, 0.85); backdrop-filter: blur(8px); display: flex; justify-content: center; align-items: center; z-index: 2000; }
                .modal-glass-card { background: white; width: 92%; max-width: 400px; border-radius: 30px; padding: 35px; position: relative; }
                .icon-badge-yellow { width: 60px; height: 60px; background: #fffbeb; color: #f59e0b; border-radius: 18px; display: flex; align-items: center; justify-content: center; font-size: 2rem; }
                .btn-close-circle { border: none; background: #f1f5f9; border-radius: 50%; width: 35px; height: 35px; display: flex; align-items: center; justify-content: center; color: #64748b; transition: 0.3s; }
                .btn-close-circle:hover { background: #e2e8f0; color: #0f172a; }
                .form-control:focus { box-shadow: none; background: #f8fafc !important; border: 1px solid #fbbf24 !important; }
            `}</style>
        </div>
    );
};

export default RatingModal;